const sizeConfigs = {
    sidebar: {
        width: "210px",
        halfwidth: "80px"
    }
};

export default sizeConfigs;